export default function ClockRotateIcon(props) {
  const { ...rest } = props;
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fill={props?.fill || '#fff'}
        d="M8.5 0C12.9187 0 16.5 3.58125 16.5 8C16.5 12.4187 12.9187 16 8.5 16C6.86875 16 5.35 15.5125 4.08437 14.6719C3.74062 14.4438 3.64687 13.9781 3.84687 13.6344C4.10312 13.2875 4.56875 13.1938 4.91563 13.4219C5.94063 14.1031 7.17188 14.5 8.5 14.5C12.0906 14.5 15 11.5906 15 8C15 4.40938 12.0906 1.5 8.5 1.5C6.2 1.5 4.17812 2.695 3.02156 4.5H4.75C5.16563 4.5 5.5 4.83437 5.5 5.25C5.5 5.66563 5.16563 6 4.75 6H1.25C0.835938 6 0.5 5.66563 0.5 5.25V1.75C0.5 1.33594 0.835938 1 1.25 1C1.66406 1 2 1.33594 2 1.75V3.33437C3.45156 1.31625 5.82188 0 8.5 0ZM8.5 4C8.91562 4 9.25 4.33437 9.25 4.75V7.69063L11.2531 9.71875C11.5719 10.0125 11.5719 10.4875 11.2531 10.7531C10.9875 11.0719 10.5125 11.0719 10.2188 10.7531L7.96875 8.50313C7.82812 8.39062 7.75 8.2 7.75 8V4.75C7.75 4.33437 8.08437 4 8.5 4Z"
      />
    </svg>
  );
}
